import { Editor, PluginManager } from "tinymce";
import { EditorInteractionManager } from "./types";
import { CaptureErrorFunc } from "../use-error-logger";

export const createEditorInteractionManager = (pluginManager: PluginManager, editor: Editor, captureError: CaptureErrorFunc): EditorInteractionManager => {
    const registerPlugin = (id: string, addOnCallback) => {

        pluginManager.add(id, (editor: Editor) => {
          const addButton = editor.ui.registry.addButton;
          const addContextToolbar = editor.ui.registry.addContextToolbar;
          const addContextMenu = editor.ui.registry.addContextMenu;
          const addIcons = (icons: Record<string, string>) => Object.entries(icons).forEach(([key, value]) => editor.ui.registry.addIcon(key, value));
          const addMenuItem = editor.ui.registry.addMenuItem;

          try {
            addOnCallback({
              addButton,
              addContextToolbar,
              addContextMenu,
              addMenuItem,
              addIcons,
              on: (event: string, callback: (e: KeyboardEvent) => void) => editor.on(event, callback),
            });
          } catch (error) {
            captureError('Error occurred while registering plugin', error, id);
          }
        });
      };

    return {
        registerPlugin,
        replaceContent: (content: string) => editor.execCommand('mceReplaceContent', false, content),
        insertContent: (content: string) => editor.execCommand('mceInsertContent', false, content),
        justifyCenter: () => editor.execCommand('JustifyCenter'),
        selectNode: (node: Element) => editor.execCommand('mceSelectNode', false, node),
        selectNodeDepth: (depth: number) => editor.execCommand('mceSelectNodeDepth', false, depth),
        deleteNodeContent: () => editor.execCommand('Delete'),
        deleteNode: () => editor.execCommand('mceRemoveNode'),
        getSelectedNode: () => editor.selection.getNode(),
        getSelectedText: () => editor.selection.getContent({ format: 'text' }),
        queryCommandState: (command: string) => editor.queryCommandState(command),
    };
};
